module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "scroll-wrap"
  }, [_c('div', {
    ref: "scrollBar",
    staticClass: "container",
    attrs: {
      "id": "scrollBar"
    },
    on: {
      "scroll": _vm.onScroll
    }
  }, [_c('div', {
    ref: "pageIndex",
    staticClass: "page-index"
  }, [_c('pathAirPlane', {
    ref: "svgPathEl"
  }), _vm._v(" "), _c('first', {
    staticClass: "page",
    attrs: {
      "id": "index"
    }
  }), _vm._v(" "), _c('pageMain', {
    ref: "mainPage",
    staticClass: "page",
    attrs: {
      "id": "main"
    }
  }), _vm._v(" "), _c('point1', {
    staticClass: "page",
    attrs: {
      "id": "point1"
    }
  }), _vm._v(" "), _c('point2', {
    staticClass: "page",
    attrs: {
      "id": "point2"
    }
  }), _vm._v(" "), _c('point3', {
    staticClass: "page",
    attrs: {
      "id": "point3"
    }
  }), _vm._v(" "), _c('point4', {
    staticClass: "page",
    attrs: {
      "id": "point4"
    }
  }), _vm._v(" "), _c('point5', {
    staticClass: "page",
    attrs: {
      "id": "point5"
    }
  }), _vm._v(" "), _c('competition', {
    attrs: {
      "id": "competition"
    }
  }), _vm._v(" "), _c('last', {
    staticClass: "page",
    attrs: {
      "id": "picnic"
    }
  })], 1)]), _vm._v(" "), _c(_vm.popup, {
    tag: "component"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e853781","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Index.vue
// module id = 535
// module chunks = 1